import React, { useState } from 'react';
import { Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import CookiePreferencesModal from './CookiePreferencesModal';
import {
  saveLocalConsent,
  createConsentPayload,
  initializeTrackers,
  getOrCreateAnonymousId
} from './consentManager';
import { base44 } from '@/api/base44Client';

export default function CookieSettingsLink({ variant = 'link', className = '' }) {
  const [showPreferences, setShowPreferences] = useState(false);

  const handleSavePreferences = async (preferences) => {
    // Sauvegarder localement
    saveLocalConsent(preferences);
    
    // Tenter de sauvegarder en DB
    try {
      const user = await base44.auth.me();
      const payload = createConsentPayload(preferences, user?.id);
      await base44.entities.CookieConsent.create(payload);
    } catch (error) {
      console.error('Error saving consent:', error);
    }
    
    setShowPreferences(false);
    
    // Recharger la page pour appliquer les nouveaux paramètres
    window.location.reload();
  };

  if (variant === 'button') {
    return (
      <>
        <Button
          onClick={() => setShowPreferences(true)}
          variant="outline"
          className={className}
        >
          <Settings className="w-4 h-4 mr-2" />
          Gérer mes cookies
        </Button>
        <CookiePreferencesModal
          isOpen={showPreferences}
          onClose={() => setShowPreferences(false)}
          onSave={handleSavePreferences}
        />
      </>
    );
  }

  return (
    <>
      <button
        onClick={() => setShowPreferences(true)}
        className={`text-slate-400 hover:text-white transition-colors ${className}`}
      >
        Gérer mes cookies
      </button>
      <CookiePreferencesModal
        isOpen={showPreferences}
        onClose={() => setShowPreferences(false)}
        onSave={handleSavePreferences}
      />
    </>
  );
}